<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form [formGroup]="form">
  <div mat-dialog-content class="qualificates-theme">

    @if (data.equipment.fromProtocol) {
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>
              {{ 'protocolEdit.dialog.equipment.type.label' | translate }} {{ 'common.inProtocol' | translate }}
            </mat-label>
            <mat-select required name="idTypeProtocol" [ngModel]="data.equipment.idTypeProtocol" disabled [ngModelOptions]="{standalone: true}">
              @for (item of equipmentTypes; track item) {
                <mat-option [value]="item.id">
                  {{ 'equipmentType.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="equipmentProtocol" [(ngModel)]="data.equipment.equipmentProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="makerProtocol" [(ngModel)]="data.equipment.makerProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="modelProtocol" [(ngModel)]="data.equipment.modelProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="serialNumProtocol" [(ngModel)]="data.equipment.serialNumProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="internalIdProtocol" [(ngModel)]="data.equipment.internalIdProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput name="locationProtocol" [(ngModel)]="data.equipment.locationProtocol" disabled [ngModelOptions]="{standalone: true}">
          </mat-form-field>
        </div>
        @if (showIsCentrifuge()) {
          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.equipment.rotorModel.label' | translate }}</mat-label>
              <input matInput
                formControlName="rotorModel" [(ngModel)]="data.equipment.rotorModelProtocol"  disabled [ngModelOptions]="{standalone: true}">
              <mat-error>
                {{ 'protocolEdit.dialog.equipment.rotorModel.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
        @if (showIsCentrifuge()) {
          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.equipment.rotorSerial.label' | translate }}</mat-label>
              <input matInput
                formControlName="rotorSerial" [(ngModel)]="data.equipment.rotorSerialProtocol">
              <mat-error>
                {{ 'protocolEdit.dialog.equipment.rotorSerial.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
      </div>
    }

    <div fxLayout="row" class="flexwrap">

      <div fxFlex="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.type.label' | translate }}</mat-label>
          <mat-select required formControlName="idType" [(ngModel)]="data.equipment.idType">
            @for (item of equipmentTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'equipmentType.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'executionEdit.dialog.equipment.type.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.equipment.label' | translate }}</mat-label>
          <input matInput
            formControlName="equipment" [(ngModel)]="data.equipment.equipment" required>
          <mat-error>
            {{ 'executionEdit.dialog.equipment.equipment.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.maker.label' | translate }}</mat-label>
          <input matInput
            formControlName="maker" [(ngModel)]="data.equipment.maker">
          <mat-error>
            {{ 'executionEdit.dialog.equipment.maker.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.model.label' | translate }}</mat-label>
          <input matInput
            formControlName="model" [(ngModel)]="data.equipment.model">
          <mat-error>
            {{ 'executionEdit.dialog.equipment.model.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
          <input matInput
            formControlName="serialNum" [(ngModel)]="data.equipment.serialNumber">
          <mat-error>
            {{ 'executionEdit.dialog.equipment.serialNum.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.internalId.label' | translate }}</mat-label>
          <input matInput
            formControlName="internalId" [(ngModel)]="data.equipment.internalId">
          <mat-error>
            {{ 'executionEdit.dialog.equipment.internalId.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.dialog.equipment.location.label' | translate }}</mat-label>
          <input matInput
            formControlName="location" [(ngModel)]="data.equipment.location" required>
          <mat-error>
            {{ 'executionEdit.dialog.equipment.location.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      @if (showIsCentrifuge()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionEdit.dialog.equipment.rotorModel.label' | translate }}</mat-label>
            <input matInput
              formControlName="rotorModel" [(ngModel)]="data.equipment.rotorModel">
            <mat-error>
              {{ 'executionEdit.dialog.equipment.rotorModel.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }
      @if (showIsCentrifuge()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionEdit.dialog.equipment.rotorSerial.label' | translate }}</mat-label>
            <input matInput
              formControlName="rotorSerial" [(ngModel)]="data.equipment.rotorSerial">
            <mat-error>
              {{ 'executionEdit.dialog.equipment.rotorSerial.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }

      @if (showEquipmentAllowed()) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{'protocolEdit.dialog.equipment.mappingType.label' | translate }}</mat-label>
            <mat-select [(ngModel)]="data.equipment.mappingType" name="mappingType" formControlName="mappingType">
              <mat-option>--</mat-option>
              @for (item of mappingTypes; track item) {
                <mat-option [value]="item.value">
                  {{ 'mappingType.' + item.value | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>

    <div fxLayout="row" class="flexwrap">
      @if (requiredReason()) {
        <div fxFlex="100">
          <mat-label>{{ 'common.reasonChange' | translate }}</mat-label>
          <textarea rows="5" matAutosizeMinRows="5" matInput
          [(ngModel)]="data.equipment.reasonChange" name="reasonChange" required style="resize: none;" [ngModelOptions]="{standalone: true}"></textarea>
        </div>
      }
    </div>

    @if (data.equipment.fromProtocol) {
      <div fxLayout="column" class="flexwrap">
        <div fxFlex>
          <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.equipment.showDiffInDeviations" [ngModelOptions]="{standalone: true}">
            {{ 'protocolEdit.dialog.equipment.showDiffInDeviations.label' | translate }}
          </mat-checkbox>
        </div>
        <div fxFlex>
          <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.equipment.showDiffInObservations" [ngModelOptions]="{standalone: true}">
            {{ 'protocolEdit.dialog.equipment.showDiffInObservations.label' | translate }}
          </mat-checkbox>
        </div>
      </div>
    }

  </div>
  <div mat-dialog-actions class="qualificates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>